import { design, site_web } from "../../datas/CardOffreDetailsData.js"
import CardOffreDetails from "./CardOffreDetails.jsx"

function CardListDetails({ color, service }) {
    const data = service === "design" ? design : site_web

    return (
        <>
            {data.map(
                ({ titre, texte, prix, monnaie, sous_texte, id, ...lines }) => (
                    <CardOffreDetails
                        key={id}
                        titre={titre}
                        texte={texte}
                        prix={prix}
                        monnaie={monnaie}
                        sous_texte={sous_texte}
                        color={color}
                        lines={lines}
                    />
                ),
            )}
        </>
    )
}

export default CardListDetails
